import each from 'lodash/each';
import isEmpty from 'lodash/isEmpty';
import assign from 'lodash/assign';
import cloneDeep from 'lodash/cloneDeep';
import { INITIAL_STATUS, STORE_REQUEST_STATUS } from '../const/store.const';
import { getScopeAndValue } from './payload';
export const initialState = {
    STATUS: Object.assign({}, INITIAL_STATUS),
    data: [],
    error: null,
    isLoading: false,
    isLoaded: false,
};
export function setData(state, payload) {
    const { scope, value } = getScopeAndValue(payload);
    if (scope) {
        state[scope].data = value;
    }
    else {
        state.data = value;
    }
}
export function setError(state, payload) {
    const { scope, value } = getScopeAndValue(payload);
    if (scope) {
        state[scope].error = value;
    }
    else {
        state.error = value;
    }
}
export function setStatus(state, payload) {
    const { scope, value } = getScopeAndValue(payload);
    const isLoading = value === STORE_REQUEST_STATUS.loading;
    const isLoaded = value === STORE_REQUEST_STATUS.loaded;
    if (scope) {
        state[scope].isLoading = isLoading;
        state[scope].isLoaded = isLoaded;
    }
    else {
        state.isLoading = isLoading;
        state.isLoaded = isLoaded;
    }
    // @deprecated
    const states = scope ? state[scope].STATUS : state.STATUS;
    each(states, (_isActive, key) => {
        states[key] = key === value;
    });
}
/**
 * Allows to clear the data of the generic or any scope, payload is composed by `scopes` string[] and defaultValue: any
 * @param state
 * @param payload { ResetPayload }
 */
export function clearData(state, payload) {
    const { scopes = [], defaultValue = [], } = payload;
    if (!scopes || isEmpty(scopes)) {
        state.data = defaultValue;
    }
    else {
        each(scopes, (scope) => {
            state[scope].data = defaultValue;
        });
    }
}
/**
 * Allows to reset the state of the generic or any scope, payload is composed by `scopes` string[] and defaultValue: any
 * @param state
 * @param payload { ResetPayload }
 */
export function resetState(state, payload) {
    const { scopes = [], defaultValue = initialState, } = payload;
    if (isEmpty(scopes)) {
        assign(state, cloneDeep(defaultValue));
    }
    else {
        each(scopes, (scope) => {
            assign(state[scope], cloneDeep(defaultValue));
        });
    }
}
